import { render, staticRenderFns } from "./FormButtonsContainer.vue?vue&type=template&id=618d7580&"
import script from "./FormButtonsContainer.vue?vue&type=script&lang=js&"
export * from "./FormButtonsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports